<template>
  <div
    class="scrolling"
    :class="isMobile ? '' : 'd-flex flex-row flex-nowrap overflow-auto'"
  >
    <div v-for="(option, index) in options" :key="index">
      <div
        v-if="visible(option)"
        class="middle"
        :class="!isMobile && 'col-1 col-md-3 col-xl-1'"
      >
        <label class="mr-3">
          <input
            type="radio"
            name="radio"
            :checked="value === option.value"
            :value="option.value"
            :id="option.name + index"
            :disabled="disabled"
            @input="updateValue($event.target.value)"
          />
          <div
            v-if="!disabled"
            class="front-end box d-block mx-auto d-flex justify-content-center align-items-center"
          >
            <i v-if="option.icon.includes('fas fa')" :class="option.icon"></i>
            <img
              v-if="!option.icon.includes('fas fa')"
              style="filter:grayscale(100%)"
              :src="showImage(option.icon)"
            />
            <span>{{ option.name }}</span>
          </div>
          <div
            v-else
            class="front-end d-block mx-auto d-flex justify-content-center align-items-center disable"
          >
            <i v-if="option.icon.includes('fas fa')" :class="option.icon"></i>
            <img
              v-if="!option.icon.includes('fas fa')"
              style="filter:grayscale(100%)"
              :src="showImage(option.icon)"
            />
            <span>{{ option.name }}</span>
          </div>
        </label>
      </div>
    </div>
    <div v-if="error" class="col-12 mt-n4">
      <error variant="no-border" :message="customErrorMsg" />
    </div>
  </div>
</template>

<script>
import Error from '@/components/common/Error';
export default {
  name: 'RadioButtonBigSquare',
  components: {
    Error,
  },
  props: {
    value: {
      type: [String, Boolean, Number],
      default: '',
      meta: {
        description: 'Parámetro de entrada del CustomRadio',
        example: '',
      },
    },
    options: {
      type: Array,
      default: () => [],
      meta: {
        description: 'Posibilita elegir entre varios artículos',
        example: '"[4, 8, 15, 16, 23, 42]',
      },
    },
    error: {
      type: String,
      default: '',
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      },
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      meta: {
        description: 'Estado deshabilitado',
        example: 'disabled',
      },
    },
    handleTopicChange: {
      type: Function,
      default: () => {},
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      oldTopic: 0,
    };
  },
  computed: {
    visible() {
      return (opt) => {
        const result = 'visible' in opt ? opt.visible : true;
        return result;
      };
    },
  },
  methods: {
    showImage(imgName) {
      try {
        return require(`@/assets/img/${imgName}`);
      } catch {
        return require('@/assets/logo.svg');
      }
    },
    async updateValue(value) {
      let canChange = true;

      if (this.oldTopic == 0) {
        this.oldTopic = value;
      }

      if (this.handleTopicChange != undefined) {
        canChange = await this.handleTopicChange(this.oldTopic != value);
      }
      if (canChange) {
        if (value === 'true') {
          this.$emit('input', true);
        } else if (value === 'false') {
          this.$emit('input', false);
        } else {
          this.$emit('input', value);
        }
        this.oldTopic = value;
      } else {
        this.$emit('input', parseInt(this.oldTopic));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/v2/brand_variables.scss';

.scrolling {
  display: flex;
  padding: 25px 0px;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
}

::-webkit-scrollbar {
  width: 0.5rem;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 1px white;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #e2e2e2;
  border-radius: 10px;
}

p {
  color: #727272;
}

.middle {
  margin-bottom: 5rem !important;

  input[type='radio'] {
    display: none;

    & + .box {
      background-color: #fafafa;

      span {
        color: #b5c3bc;
        transform: translateY(70px);

        &:before {
          transform: translateY(0px);
          opacity: 1;
        }
      }

      i {
        color: #b5c3bc;
        font-size: 3rem;

        &:before {
          transform: translateY(0px);
          opacity: 1;
        }
      }
    }

    &:checked {
      + .box {
        background-color: #fce0c8;
        border: 1px solid #fce0c8;

        span {
          color: $orange;
          transform: translateY(70px);

          &:before {
            transform: translateY(0px);
            opacity: 1;
          }
        }

        i {
          color: $orange;
          font-size: 3rem;

          &:before {
            transform: translateY(0px);
            opacity: 1;
          }
        }
      }
    }
  }

  input[type='radio']:disabled {
    cursor: not-allowed;
    pointer-events: none;
    display: none;

    & + .disable {
      background-color: #fafafa;

      span {
        color: #727272;
        transform: translateY(70px);

        &:before {
          transform: translateY(0px);
          opacity: 1;
        }
      }

      i {
        color: #b5c3bc;
        font-size: 3rem;

        &:before {
          transform: translateY(0px);
          opacity: 1;
        }
      }
    }

    &:checked {
      + .disable {
        background-color: #e2e2e2;
        border: 1px solid #e2e2e2;

        span {
          color: #727272;
          transform: translateY(70px);

          &:before {
            transform: translateY(0px);
            opacity: 1;
          }
        }

        i {
          color: $white;
          font-size: 3rem;

          &:before {
            transform: translateY(0px);
            opacity: 1;
          }
        }
      }
    }
  }

  .box {
    width: 111px;
    height: 111px;
    background-color: $white;
    transition: all 250ms ease;
    will-change: transition;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    position: relative;
    font-weight: bold;
    border-radius: 7px;
    border: 1px solid #e2e2e2;

    &:active {
      transform: translateY(10px);
    }

    span {
      position: absolute;
      transform: translate(0, 60px);
      left: 0;
      right: 0;
      top: 45%;
      transition: all 300ms ease;
      font-size: 16px;
      user-select: none;
      color: $green;
    }
  }

  .disable {
    width: 111px;
    height: 111px;
    background-color: $white;
    display: inline-block;
    text-align: center;
    cursor: not-allowed;
    position: relative;
    font-weight: bold;
    border-radius: 7px;
    border: 1px solid #e2e2e2;

    span {
      position: absolute;
      transform: translate(0, 60px);
      left: 0;
      right: 0;
      top: 45%;
      font-size: 16px;
      user-select: none;
      color: $green;
    }
  }
}

@media (min-width: 1200px) and (max-width: 1600px) {
  .col-xl-1 {
    max-width: 13.333333% !important;
  }
}
</style>
